import { render, staticRenderFns } from "./prompt-with-select.vue?vue&type=template&id=07236280"
import script from "./prompt-with-select.vue?vue&type=script&lang=js"
export * from "./prompt-with-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports